webpackJsonp([9],{

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaUpload_vue__ = __webpack_require__(789);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a180f8ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaUpload_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a180f8ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'media-upload',
  data: function data() {
    return {
      media: []
    };
  },
  computed: {
    mediaUploadUrl: function mediaUploadUrl() {
      return this.$store.getters['wordpress/account/url'] + this.$store.getters['wordpress/media/uploadPath'];
    }
  },
  methods: {
    /**
     * el-uploadコンポーネントのHTTP Request処理を指定
     */
    onHttpRequest: function onHttpRequest(option) {
      this.$store.dispatch('wordpress/media/create', option);
    },
    onSubmit: function onSubmit(ev) {
      this.$refs.upload.submit();
    },
    onPreview: function onPreview(ev) {
      // console.log(ev)
    },
    onRemove: function onRemove(ev) {
      // console.log(ev)
    }
  }
});

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(838);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("373e5d71", content, true, {});

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".image-uploader,.image-uploader .el-upload,.image-uploader .el-upload-dragger{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/routes/MediaUpload.vue"],"names":[],"mappings":"AAIA,8EAEI,UAAY,CACf","file":"MediaUpload.vue","sourcesContent":["\n.image-uploader {\n  width: 100%;\n}\n.image-uploader .el-upload,\n  .image-uploader .el-upload-dragger {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-section"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"padding"},[_c('el-upload',{ref:"upload",staticClass:"image-uploader",attrs:{"drag":"","action":_vm.mediaUploadUrl,"on-preview":_vm.onPreview,"on-remove":_vm.onRemove,"file-list":_vm.media,"list-type":"picture","multiple":true,"http-request":_vm.onHttpRequest}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("ファイルをドラッグするか"),_c('em',[_vm._v("クリックしてアップロードしてください")]),_vm._v("。"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("ファイル名は英数字にしてください。")])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header flex justify-between items-center"},[_c('h2',{staticClass:"app-h2"},[_vm._v("画像の新規アップロード")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.3c56994f64e8c82fda79.js